import type { Modifier } from '@dnd-kit/core';

/**
 * Keeps a dragged row in its column. The lists on a roster board are single columns, so sideways
 * movement only ever drags a row out over its neighbours. (The same modifier ships in
 * @dnd-kit/modifiers, which this app does not otherwise need.)
 */
export const restrictToVerticalAxis: Modifier = ({ transform }) => ({ ...transform, x: 0 });
